import MhdExpenseSummaryExplorer from "./MhdExpenseSummaryExplorer";

const Expenses = () => {
  return <MhdExpenseSummaryExplorer />;
};

export default Expenses;
